import React, { useState, useEffect, useRef } from 'react';
import Slider from 'react-slick';
import './AlwaysConnectedSlider.scss';
import leftArrow from '../../../../assets/smartxonnect/left.webp';
import rightArrow from '../../../../assets/smartxonnect/right.webp';
import whiteLeftArrow from '../../../../assets/smartxonnect/white-left-arrow.webp';
import whiteRightArrow from '../../../../assets/smartxonnect/white-left-arrow.webp';

const PrevArrow = (props) => {
  const { className, onClick, isDisabled } = props;

  const handlePrevClick = () => {
    if (!isDisabled) {
      dataLayer.push({
        event: 'always_connected_banner_navigation',
        action: 'previous_arrow_clicked',
        BrandName: 'TVS iQube',
        VariantName: 'SmartXonnect',
      });
      onClick();
    }
  };

  return (
    <div className={`${className} custom-prev-arrow`} onClick={handlePrevClick}>
      <img src={isDisabled ? whiteLeftArrow : leftArrow} alt="Previous" loading="lazy" />
    </div>
  );
};

const NextArrow = (props) => {
  const { className, onClick, isDisabled } = props;

  const handleNextClick = () => {
    if (!isDisabled) {
      dataLayer.push({
        event: 'always_connected_banner_navigation',
        action: 'next_arrow_clicked',
        BrandName: 'TVS iQube',
        VariantName: 'SmartXonnect',
      });
      onClick();
    }
  };

  return (
    <div className={`${className} custom-next-arrow`} onClick={handleNextClick}>
      <img
        src={isDisabled ? whiteLeftArrow : rightArrow}
        alt="Next"
        className={isDisabled ? 'disabled' : 'rotate-180'}
        loading="lazy"
      />
    </div>
  );
};

const AlwaysConnectedSlider = (props) => {
  const [currentSlide, setCurrentSlide] = useState(0);
  const [isFirstSlide, setIsFirstSlide] = useState(true);
  const [isLastSlide, setIsLastSlide] = useState(false);
  const sliderRef = useRef(null);
  const [isDataLayerTriggered, setIsDataLayerTriggered] = useState(false);

  const totalSlides = props?.fields?.SliderCards?.length || 0;
  const slidesToShow = 4;

  const handleDotsClick = (index) => {
    const dotNumber = `dot ${index + 1}`;
    dataLayer.push({
      event: 'on_the_way_banner_navigation',
      cta_text: dotNumber,
      BrandName: 'TVS iQube',
      VariantName: 'SmartXonnect',
    });
  };
  const settings = {
    dots: true,
    infinite: false,
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: 4,
    prevArrow: <PrevArrow isDisabled={isFirstSlide} />,
    nextArrow: <NextArrow isDisabled={isLastSlide} />,
    appendDots: (dots) => (
      <ul className="slick-dots">
        {dots.map((dot, index) => (
          <li key={index} onClick={() => handleDotsClick(index)}>
            {dot}
          </li>
        ))}
      </ul>
    ),
    responsive: [
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 3,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 480,
        settings: {
          slidesToShow: 1.15,
          slidesToScroll: 1,
        },
      },
    ],
    afterChange: (current) => {
      setCurrentSlide(current);
      setIsFirstSlide(current === 0);
      setIsLastSlide(current + slidesToShow >= totalSlides);
    },
  };

  const triggerDataLayer = () => {
    if (!isDataLayerTriggered) {
      dataLayer.push({
        event: 'always_connected_banner_navigation',
        BrandName: 'TVS iQube',
        VariantName: 'SmartXonnect',
      });
      setIsDataLayerTriggered(true);
    }
  };

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            triggerDataLayer();
          }
        });
      },
      { threshold: 0.5 }
    );

    if (sliderRef.current) {
      observer.observe(sliderRef.current);
    }

    return () => {
      if (sliderRef.current) {
        observer.unobserve(sliderRef.current);
      }
    };
  }, [isDataLayerTriggered, props?.fields?.BrandName, props?.fields?.VariantName]);

  return (
    <div
      className="always-connected-slider-wrapper commonContainer"
      data-aos="fade-up"
      ref={sliderRef}
    >
      <div className="header-section">
        <h2 className="mainHeader commmon-header">{props?.fields?.Heading?.value}</h2>
        <h4 className="subHeading roboto-bold">{props?.fields?.Title?.value}</h4>
      </div>
      <Slider {...settings}>
        {props?.fields?.SliderCards?.map((slide, index) => (
          <div className="always-connected-slider-card" key={index}>
            <div className="always-connected-slider-content">
              <h2 className="roboto-bold always-connected-title">{slide.fields.CardTitle.value}</h2>
              <p className="roboto-regular always-connected-subtitle">
                {slide.fields.CardSubtitle.value}
              </p>
            </div>
            <div className="always-connected-slider-image">
              <img
                src={`${slide.fields.CardMedia.value.src}`}
                alt={`Slide ${index + 1}`}
                loading="lazy"
              />
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default React.memo(AlwaysConnectedSlider);
